// extracted by mini-css-extract-plugin
module.exports = {"item":"styles-module__item___3PM0-"};